import { PlacementData, PlacementSizeType, PlacementType } from './types';

export const Placements: Record<PlacementType, PlacementData> = {
  Banner: {
    name: _TL_('300 x 50 — Banner'),
    size: '300x50',
    width: 300,
    height: 50,
  },
  Billboard: {
    name: _TL_('970 x 250 — Billboard'),
    size: '970x250',
    width: 970,
    height: 250,
  },
  FullBanner: {
    name: _TL_('468 x 60 — Full banner'),
    size: '468x60',
    width: 468,
    height: 60,
  },
  HalfBanner: {
    name: _TL_('234 x 60 — Half-banner'),
    size: '234x60',
    width: 234,
    height: 60,
  },
  HalfPage: {
    name: _TL_('300 x 600 — Half-page'),
    size: '300x600',
    width: 300,
    height: 600,
  },
  LargeBanner: {
    name: _TL_('216 x 36 — Large banner'),
    size: '216x36',
    width: 216,
    height: 36,
  },
  LandscapeLargeBanner: {
    name: _TL_('320 x 100 — Landscape large banner'),
    size: '320x100',
    width: 320,
    height: 100,
  },
  LargeRectangle: {
    name: _TL_('336 x 280 — Large rectangle'),
    size: '336x280',
    width: 336,
    height: 280,
  },
  Landscape: {
    name: _TL_('480 x 320 — Landscape'),
    size: '480x320',
    width: 480,
    height: 320,
  },
  SmallLeaderboard: {
    name: _TL_('320 x 50 — Small leaderboard'),
    size: '320x50',
    width: 320,
    height: 50,
  },
  Leaderboard: {
    name: _TL_('728 x 90 — Leaderboard'),
    size: '728x90',
    width: 728,
    height: 90,
  },
  MediumBanner: {
    name: _TL_('168 x 28 — Medium banner'),
    size: '168x28',
    width: 168,
    height: 28,
  },
  MediumRectangle: {
    name: _TL_('300 x 250 — Medium rectangle'),
    size: '300x250',
    width: 300,
    height: 250,
  },
  Portrait: {
    name: _TL_('320 x 480 — Portrait'),
    size: '320x480',
    width: 320,
    height: 480,
  },
  Rectangle: {
    name: _TL_('180 x 150 — Rectangle'),
    size: '180x150',
    width: 180,
    height: 150,
  },
  Skyscraper: {
    name: _TL_('120 x 600 — Skyscraper'),
    size: '120x600',
    width: 120,
    height: 600,
  },
  SmallBanner: {
    name: _TL_('120 x 20 — Small banner'),
    size: '120x20',
    width: 120,
    height: 20,
  },
  Square: {
    name: _TL_('250 x 250 — Square'),
    size: '250x250',
    width: 250,
    height: 250,
  },
  SuperLeaderboard: {
    name: _TL_('970 x 90 — Super leaderboard'),
    size: '970x90',
    width: 970,
    height: 90,
  },
  WideSkyscraper: {
    name: _TL_('160 x 600 — Wide skyscraper'),
    size: '160x600',
    width: 160,
    height: 600,
  },
};

export const SizeToType: Record<PlacementSizeType, PlacementType> = {
  '300x50': 'Banner',
  '970x250': 'Billboard',
  '468x60': 'FullBanner',
  '234x60': 'HalfBanner',
  '300x600': 'HalfPage',
  '216x36': 'LargeBanner',
  '320x100': 'LandscapeLargeBanner',
  '336x280': 'LargeRectangle',
  '480x320': 'Landscape',
  '320x50': 'SmallLeaderboard',
  '728x90': 'Leaderboard',
  '168x28': 'MediumBanner',
  '300x250': 'MediumRectangle',
  '320x480': 'Portrait',
  '180x150': 'Rectangle',
  '120x600': 'Skyscraper',
  '120x20': 'SmallBanner',
  '250x250': 'Square',
  '970x90': 'SuperLeaderboard',
  '160x600': 'WideSkyscraper',
};
